import React from 'react';
import { Map, OrderedMap } from 'immutable';
import Dropdown from 'shared/components/menus/dropDown';
import SearchActions from 'flux/actions/SearchActions';

var debug = require('debug')('shoflo:shared:components:menus:shows.jsx');

export default React.createClass({
  propTypes: {
    activeId: React.PropTypes.string.isRequired,
    shows: React.PropTypes.object.isRequired, //OrderedMap<Show>
    onChange: React.PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      noCaret: false,
    };
  },

  render() {
    const { shows } = this.props;

    if (!shows || shows.size === 0) return null;

    return (
      <div className="show-selector-dropdown">
        <Dropdown config={this._getConfig()} />
      </div>
    );
  },

  _getConfig() {
    const { activeId, shows, isGuestPass } = this.props;

    //If no active show just select first show in show list
    const activeShow =
      activeId && shows && shows.has(activeId)
        ? shows.get(activeId)
        : shows.first();
    const showTitle = this._getFormattedContent(activeShow);

    if (showTitle && document.title !== showTitle) document.title = showTitle;

    const eventHomeItem = !isGuestPass
      ? null
      : OrderedMap({
          guestPassHome: Map({
            type: 'link',
            content: 'Event Home',
            onClick: () => this._openEventHome(),
          }),
        });

    const showItems = this._getOrderedMapOfItems(activeId);

    const items = eventHomeItem ? eventHomeItem.merge(showItems) : showItems;

    return Map({
      noCaret: this.props.noCaret,
      icon: null,
      content: showTitle,
      items,
    });
  },

  _getOrderedMapOfItems(activeId) {
    let { shows } = this.props;
    if (!shows || shows.size < 1) return;

    shows = shows.filter((show) => {
      if (show) {
        return show.get('_id') !== activeId;
      }
    });

    return shows.map((show, showId) => {
      return OrderedMap({
        type: 'link',
        content: this._getFormattedContent(show),
        onClick: () => this._handleShowSelection(showId),
        displayType: show.get('displayType'),
      });
    });
  },

  _getFormattedContent(show) {
    return show.get('title');
  },

  _handleShowSelection(id) {
    debug('_handleShowSelection: ', id);
    //TODO: Add action handler for show selection

    // Fix for Issue#2282
    SearchActions.toggleVisibility(false);

    this.props.onChange(this.props.shows.get(id));
  },

  _openEventHome() {
    const showUrl = window.location.href;
    const guestEventHomeUrl = showUrl.split('shows')[0] + 'guest';

    window.location.href = guestEventHomeUrl;
  },
});
